import React from "react";
import { Box, MenuItem, Select, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import IranFlag from "../../../../../../../media/images/iranflag.png";
const ProvincePlace = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFD54F",
  ...theme.typography.body2,
  display: "flex",
  flexDirection: "column",
  borderLeft: "2px",
  borderRight: "0px",
  borderTop: "0px",
  borderBottom: "0px",
  borderStyle: "solid",
  borderColor: "#000",
  textAlign: "center",
  paddingBottom: "12px",
  paddingLeft: "8px",
  paddingRight: "8px",
  color: theme.palette.text.secondary,
  height: "70px",
}));

const ContentPlace = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFD54F",
  ...theme.typography.body2,
  display: "flex",
  gap: "4px",
  justifyContent: "center",
  alignItems: "center",
  //   border: "1px solid gray",
  textAlign: "center",
  paddingTop: "14px",
  paddingBottom: "10px",
  paddingLeft: "8px",
  paddingRight: "8px",
  height: "70px",

  color: theme.palette.text.secondary,
}));

const FlagPlace = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  ...theme.typography.body2,

  display: "flex",
  flexDirection: "column",
  //   border: "1px solid gray",
  textAlign: "center",
  paddingTop: "14px",
  paddingBottom: "15px",
  paddingLeft: "4px",
  paddingRight: "4px",
  height: "70px",
  color: theme.palette.text.secondary,
}));

export default function PelakInput() {
  const options = [
    {
      label: "ب",
      value: 2,
      disabled: false,
    },
    {
      label: "ع",
      value: 3,
      disabled: false,
    },
  ];

  return (
    <Box
      sx={{
        marginTop: "16px",
        border: "1px solid gray",
        borderRadius: "10px",
        overflow: "hidden",
        maxWidth: "80%",
        marginX: "auto",
      }}
    >
      <Grid container>
        <Grid item xs={2.5}>
          <ProvincePlace>
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: "600",
              }}
            >
              ایران
            </Typography>
            <TextField
              placeholder="55"
              size="small"
              sx={{
                borderRadius: "8px",

                backgroundColor: "background.default",

                flex: 1,
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none !important",
                  outline: "none !important",
                },
                "& .MuiInputBase-input": {
                  textAlign: "center",

                  border: "none !important",
                  outline: "none !important",
                  paddingLeft: "3px",
                  paddingRight: "3px",
                },
                "& .MuiInputBase-root": {
                  border: "none !important",
                  outline: "none !important",
                },
                border: "1px solid gray",
              }}
            />
          </ProvincePlace>
        </Grid>

        <Grid item xs={8}>
          <ContentPlace>
            <TextField
              placeholder="555"
              size="small"
              sx={{
                borderRadius: "8px",

                backgroundColor: "background.default",

                flex: 1,
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none !important",
                  outline: "none !important",
                },
                "& .MuiInputBase-input": {
                  textAlign: "center",

                  border: "none !important",
                  outline: "none !important",
                },
                "& .MuiInputBase-root": {
                  border: "none !important",
                  outline: "none !important",
                },
                border: "1px solid gray",
              }}
            />
            <Box
              sx={{
                flex: "1",
                display: "flex",
                gap: "4px",
              }}
            >
              <Select
                placeholder="ب"
                sx={{
                  backgroundColor: "background.default",
                  flex: "1",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  "& .MuiInputBase-input": {
                    border: "none !important",
                    outline: "none !important",
                    fontWeight: "600",
                  },
                  "& .MuiInputBase-root": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  "& .MuiSelect-select": {
                    paddingRight: "3px !important",
                  },
                  "& .MuiSvgIcon-root": {
                    position: "static !important",
                    left: "16px",
                    marginLeft: "10px",
                    // height: "48px !important",
                  },
                  width: "32px",
                  // height: "48px",
                  overflow: "hidden",
                  borderRadius: "8px",
                  border: "1px solid gray",
                }}
                size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                //   value={value?.toString()}
                // label="Age"
                //   onChange={onChange}
              >
                {options.map((item) => (
                  <MenuItem disabled={item.disabled} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
              <TextField
                placeholder="55"
                size="small"
                sx={{
                  borderRadius: "8px",

                  backgroundColor: "background.default",

                  flex: 1,
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  "& .MuiInputBase-input": {
                    textAlign: "center",

                    border: "none !important",
                    outline: "none !important",
                    paddingLeft: "3px",
                    paddingRight: "3px",
                  },
                  "& .MuiInputBase-root": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  border: "1px solid gray",
                }}
              />
            </Box>
          </ContentPlace>
        </Grid>
        <Grid item xs={1.5}>
          <FlagPlace>
            <img src={IranFlag} alt="" />
            <Typography
              sx={{
                fontWeight: "600",
                color: "#fff",
              }}
            >
              IR
            </Typography>
          </FlagPlace>
        </Grid>
      </Grid>
    </Box>
  );
}
